import {ScheduleState} from "@/lib/types/checks.ts";
import {UpdateContactGroupInput} from "@/lib/types/contacts.ts";

export const enum ContactTabs {
  CONTACT_INFO = "Contact Info",
  ON_CALL_HOURS = "On-Call Hours",
}

export interface IntegrationProfile {
  id: number;
  name: string;
}

export const generateDefaultContactGroupFormValues = (): UpdateContactGroupInput => ({
  name: "",
  email_list: [],
  phonecall_list: [],
  sms_list: [],
  whatsapp_list: [],
  up_alerts_email_only: false,
  integrations: [],
  push_notification_profiles: [],
  schedule_state: ScheduleState.ACTIVE,
  schedule_entries: [],
});

export interface PushNotificationProfile {
  id: number;
  display_name: string;
  is_errored: boolean;
}

export interface IntegrationProfile {
  id: number;
  name: string;
}
